import React from 'react';
import { Users, HeartHandshake, MessageSquare, Award, ClipboardCheck, Sparkles } from 'lucide-react';

const ExchangeFeatures = () => {
  const expertiseAreas = [
    { icon: Users, label: 'Sales & revenue' },
    { icon: HeartHandshake, label: 'Customer service & experience' },
    { icon: MessageSquare, label: 'Team communication & collaboration' },
    { icon: Award, label: 'Leadership & frontline enablement' },
    { icon: ClipboardCheck, label: 'Compliance & operational readiness' }
  ];

  return (
    <section className="py-20 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white">
            Powered by Experts. <span className="text-cyan-400">Always Current.</span>
          </h2>
          
          <p className="text-xl text-gray-300 mb-8">
            Traain partners with trusted experts across:
          </p>
        </div>

        <div className="max-w-4xl mx-auto mb-12">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            {expertiseAreas.map((area, index) => {
              const Icon = area.icon;
              return (
                <div
                  key={index}
                  className="flex items-center gap-4 p-5 rounded-xl bg-gradient-to-br from-gray-800/50 to-gray-900/50 border border-gray-700/50 hover:border-cyan-500/50 transition-all duration-300"
                >
                  <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-cyan-500/20 to-blue-500/20 flex items-center justify-center flex-shrink-0">
                    <Icon className="w-5 h-5 text-cyan-400" />
                  </div>
                  <p className="text-gray-300">{area.label}</p>
                </div>
              );
            })}
          </div>
        </div>

        <div className="max-w-4xl mx-auto text-center space-y-6">
          <p className="text-xl text-gray-300">
            New Training is added continuously — so teams stay <span className="text-white font-semibold">current</span>, not caught up.
          </p>
          
          <div className="inline-flex items-center gap-3 p-6 rounded-2xl bg-gradient-to-br from-cyan-900/20 to-blue-900/30 border border-cyan-500/30">
            <Sparkles className="w-6 h-6 text-cyan-400" />
            <p className="text-lg text-cyan-400 font-semibold">
              Navigator AI™ surfaces what matters most, when it matters most.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExchangeFeatures;
